module.exports = __webpack_public_path__ + "img/3-4.bb39e836.jpg";